import { ButtonBack } from "components/buttons";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";
import React from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions: React.ReactNode[];
    recordChanged: boolean;
    onBack: () => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição do Cabeçalho de Configurações
 * @param props
 */
export const EditSettingsHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////

    const { actions, recordChanged, onBack } = props;
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(recordChanged);

    ////////////////////////////////////////////////////////////////////////////

    var headerItems: React.ReactNode[] = [<ButtonBack rounded size="large" variant="text" onClick={onBack} />];
    if (actions)
        headerItems = [...headerItems, ...actions];

    return (
        <div>
            <MprcFormBarHeader actions={headerItems} />

            <MprcPrompt
                open={showPrompt}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation}
            />
        </div>
    );
};
